import {
  AgentTree,
  IAgentTreeDTO,
} from "@/modules/Segmentation/models/AgentTree";

export class Statistic {
  label: string;
  value: number;
  chart: {
    dates: string[];
    values: number[];
  };

  constructor(chart: IStatisticDTO) {
    this.label = chart.label;
    this.value = chart.value;
    this.chart = {
      dates: chart.chart.dates,
      values: chart.chart.values.map(e => +e),
    };
  }
}

export class Children extends AgentTree {
  statistics: IStatisticChildrenDTO;
  children: Children[] | null;

  constructor(child: IAgentTreeStatisticDTO) {
    super(child);
    this.statistics = child.statistics;
    this.children = child.isHasChildren ? [] : null;
    this.hasChildren = child.isHasChildren;
  }
}

export interface IStatisticDTO {
  label: string;
  value: number;
  chart: {
    dates: string[];
    values: string[];
  };
}

export type IAgentTreeStatisticDTO = IAgentTreeDTO &
  Readonly<{
    statistics: IStatisticChildrenDTO;
  }>;

export interface IStatisticChildrenDTO {
  cm_total_calc: number;
  cm_antisegment: number;
  cm_antisegment_percentage: number;
  pm_total_calc: number;
  pm_antisegment: number;
  pm_antisegment_percentage: number;
  cm_total_policies: number;
  cm_total_premium: number;
  pm_total_policies: number;
  pm_total_premium: number;
}

export type agentColumns = Readonly<{
  name: string;
  tooltip: string;
  size: number;
}>;

export type IAgentTreeStatisticHydra = { items: IAgentTreeStatisticDTO[] ; pagination: {perPage: number} };
